import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { alpha, useTheme } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
export const MCheckbox = forwardRef(({ color = 'primary', sx, ...other }, ref) => {
    const theme = useTheme();
    if (color === 'default' || color === 'primary' || color === 'secondary') {
        return _jsx(Checkbox, Object.assign({ ref: ref, color: color, sx: sx }, other), void 0);
    }
    return (_jsx(Checkbox, Object.assign({ ref: ref, sx: {
            '&.Mui-checked': {
                color: theme.palette[color].main,
            },
            '&.MuiCheckbox-indeterminate': {
                color: theme.palette[color].main,
            },
            '&:hover, &.Mui-checked:hover': {
                backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
            },
            ...sx,
        } }, other), void 0));
});
//# sourceMappingURL=MCheckbox.js.map